import { useCallback, useState } from "react";
import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import ApiBooking from "../types/ApiBooking";

type Output = ApiBooking[];

export interface BookingFilters {
    hotel?: string | string[];
}

export function useHotelMeSearchData() {
    const client = useAPIClient();

    const [data, setData] = useState<Output>([]);
    const [loading, setLoading] = useState(false);

    const fetchData = useCallback((filters: BookingFilters) => {
        setLoading(true);

        return client.get<Output>(`hotels`, {
            id: filters.hotel,
            itemsPerPage: 1000,
            "order[id]": "DESC",
        }).then((data) => {
            setData(data);
            setLoading(false);
        }).catch(() => {
            setData([]);
            setLoading(false);
        });
    }, [client]);

    return { data, loading, fetchData };
}
